import React from 'react';
import LinkPreview from 'components/Commons/LinkPreview';
import { SourceData } from 'models/user/research/ChatMessage.model';
import './SourcesView.scss';

export type SourcesViewProps = {
  sources: SourceData[];
  title?: string;
};

const SourcesView: React.FC<SourcesViewProps> = ({ sources, title = "Sources" }) => {
  if (!sources || sources.length === 0) {
    return null;
  }

  return (
    <div className="sources-view">
      <div className="sources-view__header">
        <h3 className="sources-view__title">
          <i className="material-icons">link</i>
          {title}
        </h3>
        <span className="sources-view__count">
          {sources.length} {sources.length === 1 ? 'source' : 'sources'}
        </span>
      </div>
      
      <div className="sources-view__grid">
        {sources.map((source, index) => (
          <LinkPreview
            key={`${source.url}-${index}`}
            link={source.url}
            title={source.title}
            data={source.date || source.rawDate}
          />
        ))}
      </div>
    </div>
  );
};

export default SourcesView;
